<script setup>
  import { computed } from 'vue'
  import ActiveItemFollowUp from '@/components/Event/ActiveItemFollowUp.vue'

  const props = defineProps({
    activeItem: Object
  })

  const timeString = computed(() => {
    const activeItem = props.activeItem
    if (!activeItem) return
    if (activeItem.dates[0].startDate === activeItem.dates[0].endDate) {
      return `${activeItem.dates[0].weekday.slice(0, 3)}, ${activeItem.dates[0].startTime} - ${activeItem.dates[0].endTime} Uhr`
    }
    return `${activeItem.dates[0].weekday.slice(0, 3)},  ${activeItem.dates[0].startTime} - ${activeItem.dates[0].endDay.slice(0, 3)} ${ activeItem.dates[0].endTime } Uhr`
  })

</script>

<template>
<div
  class="course-events-active-item py-12 flex flex-col items-center justify-center col-span-4 border-b border-x border-border"
>
  <div
      class="course-events-active-item-date-details max-w-[14rem]"
  >
    <div class="node-event-teaser-main-date w-full">
      <h2
        class="text-lg text-primary mb-2"
      >
        {{ activeItem.seminar }}
      </h2>
      <p class="mb-4">
        <strong>
          {{ activeItem.headline }}
        </strong>
      </p>
        <p
          class="flex flex-row items-center mb-2"
        >
          <AppIcon
            name="EventDate"
            class="mr-2"
          ></AppIcon>
          <span
            v-if="activeItem.dates[0].startDate === activeItem.dates[0].endDate"
          >
            {{ activeItem.dates[0].startDate }}
          </span>
          <span
            v-else
          >
            {{ activeItem.dates[0].startDate }} - {{ activeItem.dates[0].endDate }}
          </span>
        </p>
        <p
          class="flex flex-row items-center mb-2"
        >
          <AppIcon
            name="Clock"
            class="mr-2"
          ></AppIcon>
          <span>
            {{ timeString }}
          </span>
        </p>
        <p
          class="flex flex-row items-center mb-2"
        >
          <AppIcon
            name="EventRoute"
            class="mr-2"
          ></AppIcon>
          <span>
            {{ activeItem.location }}
          </span>
        </p>
        <p
          class="flex flex-row items-center mb-2"
        >
          <AppIcon
            name="Avatar"
            class="mr-2"
          ></AppIcon>
          <span>
            {{ 'mit ' }}
            <a
              class="underline underline-offset-4"
              :href="activeItem.speaker.url"
            >
              {{ activeItem.speaker.name }}
            </a>
          </span>
        </p>
      </div>
      <ActiveItemFollowUp
        :followUp="activeItem.followUp"
      />
    </div>
    <div
      class="course-events-active-item-actions max-w-[14rem] mt-6"
    >
      <a
        :href="activeItem.url"
        class="bg-primary text-white px-6 py-5 text-sm w-fit flex flex-row items-center rounded-full"
        :aria-label="`Zur Terminanmeldung für ${activeItem.title}`"
      >
        <AppIcon
          name="ArrowLink"
        ></AppIcon>
        Zur Anmeldung
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  :deep(svg), :slotted(svg) {
    @apply w-5 h-5;
  }
  .course-events-active-item-actions :deep(svg) {
    @apply mr-2 w-4 h-4;
  }
  .course-events-active-item-actions :deep(svg path) {
    fill: #fff !important;
  }
  .node-event-teaser-main-date {
    h2 {
      @apply hidden;
    }
  }
  .course-events-advertisement {
    @apply block;
    .node-event-teaser-main-date {
      h2 {
        @apply block;
      }
    }
  }
</style>
